import { isRepoNotRequired } from '~/constants/commands'
import { useConversationMetadata } from './conversation'

export function useRepositoryNames() {
  const { command, repository, repositories } = useConversationMetadata()
  const renderRepository = (repo: string) => {
    if (repo.includes('___')) {
      const dirname = repo.split('___').pop()?.replace('.tar.gz', '')
      return `local/${dirname}`
    }
    return repo
  }
  return isRepoNotRequired(command) && Array.isArray(repositories) && repositories.length >= 1
    ? repositories.map(renderRepository).join(', ')
    : repository
      ? renderRepository(repository)
      : 'No repository selected'
}
